
import Vue from 'vue'
import AppMixin from '@/_mixins/app'
import ModuleSettings from '@/views/Project/Settings/Components/module.vue'
import { getProject } from '@/utils/project'
import ToolbarComponent from '@/_components/bar/appToolbar/appToolbar.vue'

const ProjectModulesSettings = Vue.extend({
    mixins: [AppMixin],
    components: { ModuleSettings, ToolbarComponent },
    props: {
        project: {
            required: false,
            type: Object,
        },
        wizzard: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {
            loaded: false,
            loadingPatch: false,
            valid: false,
            // localProject: {} as Record<string, any>,
        }
    },

    computed: {
        localProject: {
            get() {
                return this.project
            },
            set(val) {
                if (!val) {
                    this.$emit('updateProject', this.localProject)
                }
            },
        },
        allowed() {
            let permissions = []
            if (this.wizzard) {
                permissions = this.project?.permissions
            } else {
                permissions = this.currentProjectPermissions
            }
            const requiredPermissions = this.requiredPermissions
                ? this.requiredPermissions
                : ['project.manage.']
            return this.hasPermission(permissions, requiredPermissions)
        },

        modulesAvailableToUser() {
            let arr = [...this.avalableModules]
            arr.filter((item) => {
                return item != 'document'
            })
            return this.isSuperuser
                ? arr
                : arr.filter((item) => {
                      return item != 'document'
                  })
        },
    },

    methods: {
        updateProjectModules(data) {
            if (data.projectModule) {
                const index = this.localProject.modules.data.findIndex(
                    (module) => module.id == data.projectModule.id
                )
                if (index > -1) {
                    this.localProject.modules.data.splice(index, 1, data.projectModule)
                } else {
                    this.localProject.modules.data.push(data.projectModule)
                }

                if (data.project) {
                    this.localProject.updatedAt = data.project.updatedAt
                    this.localProject.bklrId = data.project.bklrId
                }
            }
        },
    },

    watch: {
        project: {
            async handler() {
                this.loaded = false
                if (this.project && !this.lodash.isArray(this.project.modules.data)) {
                    this.localProject = await getProject(
                        this.project ? this.project.id : this.currentProjectId,
                        'modules'
                    )
                }
                this.loaded = false
            },
            deep: true,
            immediate: true,
        },
    },
})

export default ProjectModulesSettings
